import {AfterViewInit, Component, ViewChild} from "@angular/core";
import {ViewController, NavParams, Content, Platform} from "ionic-angular";
import {ContractService} from "../../core/contract.service";
import {SignaturePad} from "angular2-signaturepad/signature-pad";
import {ToastService} from "../../core/toast.service";
import {TranslateService} from "@ngx-translate/core";
import {AppAuth} from "../../core/auth";

@Component({
  templateUrl: 'contract-modal.component.html',
})
export class ContractModal implements AfterViewInit {
  submitted: boolean;
  @ViewChild(SignaturePad) signaturePad: SignaturePad;
  @ViewChild(Content) content: Content;
  sigPadOptions = {
    canvasHeight: 100
  };
  contract;
  signature = null;
  restoreBackButtonAction = null;

  constructor(private viewCtrl: ViewController,
              private contractService: ContractService,
              private toast: ToastService,
              private translate: TranslateService,
              private platform: Platform,
              private auth: AppAuth,
              params: NavParams) {
    this.contract = params.get('contract');
    this.signature = params.get('signature');
    this.submitted = this.hasBeenAccepted();
  }

  ngAfterViewInit() {
    if(this.needsSignature()){
      let contentEl = this.content.getNativeElement();
      let width = contentEl.clientWidth - 40;
      this.signaturePad.set('canvasWidth', width);
    }
  }

  dismiss() {
    return this.viewCtrl.dismiss();
  }

  ionViewDidEnter(){
    // Disable back button
    this.restoreBackButtonAction = this.platform.registerBackButtonAction(() => {}, 10);
  }

  ionViewDidLeave(){
    this.restoreBackButtonAction && this.restoreBackButtonAction();
  }

  clear(){
    this.signaturePad.clear();
  }

  accept() {
    if (this.needsSignature() && this.signaturePad.isEmpty()) {
      return this.toast.show(this.translate.instant('contract.please_sign'));
    }

    this.submitted = true;

    // We cannot actually tie to a user if not yet signed up
    // So we just pretend :)
    if(!this.auth.user){
      return this.dismiss();
    }

    this.contractService.accept(
      this.contract.id,
      this.needsSignature() ? this.signaturePad.toDataURL() : null)
      .subscribe(() => this.dismiss());
  }

  needsSignature(){
    return this.signature !== false;
  }

  hasBeenAccepted(){
    return typeof this.contract.pivot !== 'undefined';
  }
}



// WEBPACK FOOTER //
// ./src/app/components/contract-modal/contract-modal.component.ts